import { Accordion, AccordionDetails, AccordionSummary, Button, Card, Grid2 } from '@mui/material'
import User from 'account/dto/User'
import ActionComponent from 'components/ActionComponent'
import ColorfulCard from 'components/card/ColorfulCard'
import Input from 'components/forms/Input'
import RadioButtons from 'components/forms/RadioButtons'
import Select from 'components/forms/Select'
import SimpleTabList from 'components/list/SimpleTabList'
import ProgressCard from 'components/card/ProgressCard'
import SieauAction from 'components/sieau/SieauAction'
import { push } from '@lagunovsky/redux-react-router'
import CmsAction from 'events/actions/CmsAction'
import CmsCard from 'events/components/CmsCard'
import HomeAction from 'home/actions/HomeAction'
import { PATH_CONTENTS } from 'home/constants/RouteConstants'
import { groupBy, isEqual, orderBy } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import DtoSandreCode from 'referencial/dto/DtoSandreCode'
import i18n from 'simple-react-i18n'
import { getNewsColor } from 'utils/ColorUtil'
import { getDate, getYearDate } from 'utils/DateUtil'
import { hasValue } from 'utils/NumberUtil'
import { getUser } from 'utils/SettingUtils'
import { deleteKeys, getLabel, getMapStateToProps, getPropTypes } from 'utils/StoreUtils'
import { searchAllCharacters } from 'utils/StringUtil'
import { getDataWithHeaders } from 'utils/ExportDataUtil'

const propsToFetch = {
    cmsEvents: false,
    cmsCategories: false,
    selectedSearchValues: false,
    sandreCodes: true,
}

const initFilter = {
    level: -1,
    status: -1,
    searchValue: '',
    category: null,
}

const headers = ['title', 'comment', 'author', 'link', 'status', 'updateDate', 'startDate', 'endDate', 'x', 'y', 'category']

class ContentsApp extends ActionComponent {
    constructor(props) {
        super(props)
        this.state = {
            filter: {
                ...initFilter,
            },
            tmpFilter: {
                ...initFilter,
            },
            sortBy: 'updateDate',
            idWP: -1,
            dataLoaded: false,
        }
    }

    componentDidMount() {
        this.setActions({})
        this.props.fetchCMSEvents().then(() => {
            const { cmsCategories } = this.props
            if (!cmsCategories.length) {
                this.props.fetchCMSCategories().then(() => {
                    this.initComponent()
                })
            } else {
                this.initComponent()
            }
        })
    }

    initComponent = () => {
        const { cmsCategories, globalResearch, params } = this.props
        const { tmpFilter, filter } = this.state
        this.setState({ dataLoaded: true })
        this.setComponentActions(params.categoryId)
        if (cmsCategories.length) {
            this.setTitle(this.props, filter)
        }
        if (globalResearch) {
            this.setState({ filter: { ...filter, searchValue: globalResearch }, tmpFilter: { ...tmpFilter, searchValue: globalResearch } })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.categoryId !== nextProps.params.categoryId) {
            this.setState({
                category: nextProps.params.categoryId,
                sortBy: 'updateDate',
            })
            this.setComponentActions(nextProps.params.categoryId)
        }
    }

    setTitle(props, filter) {
        const categoryMenu = props.cmsCategories.find(c => c.id == this.props.params.categoryId)
        const category = filter.category ? (props.cmsCategories.find(c => c.id == filter.category) || {}).title || i18n.unknown : 'TOUTES'
        this.props.setTitle([{
            title: categoryMenu.menu,
            href: `${PATH_CONTENTS}/${props.params.categoryId}`,
        }, {
            title: category,
            href: `${PATH_CONTENTS}/${props.params.categoryId}`,
        }])
    }

    setComponentActions = (categoryId) => {
        const { cmsCategories, accountUser } = this.props
        const events = this.getEvents()
        const data = events.map(e => ({
            ...e,
            startDate: getDate(e.dateDebut),
            endDate: getDate(e.dateFin),
            updateDate: getDate(e.updateDate),
            category: e.categoryWPName,
        }))
        const category = cmsCategories.find(c => c.id == categoryId)
        const categoriesMenu = cmsCategories.filter(c => c.displayOnMenu && c.menu === category.menu)
        const categoriesManagers = accountUser.contributorCode ? categoriesMenu.filter(c => !c.managers || (c.managers.split(';').map(s => parseInt(s))).includes(accountUser.contributorCode)) : categoriesMenu.filter(c => !c.managers)
        if (!(getUser().consultant === '1') && categoriesManagers.length) {
            this.setActions({
                new: this.redirectToContent(0),
                referencialActions: {
                    actions: {
                        export: {
                            data: getDataWithHeaders(data, headers),
                            titleFile: i18n.communication,
                        },
                    },
                },
            })
        }
    }

    onChangeSortBy = sortById => {
        this.setState({ sortBy: sortById })
        this.props.sieauUpdate('selectedSearchValues', 'content', { sortBy: sortById })
    }

    redirectToContent = (contentId) => () => {
        const { params } = this.props
        const { filter } = this.state
        const categoryId = filter.category && filter.category != -1 ? filter.category : params.categoryId
        this.props.push(`${PATH_CONTENTS}/${categoryId}/${contentId}`)
    }

    getSortByFunction = () => {
        const { sandreCodes, cmsCategories } = this.props
        const { sortBy } = this.state
        const statusOptions = [
            { value: -1, label: i18n.all },
            ...sandreCodes.filter((c) => c.field === 'CMS.STATUS'),
        ]
        switch (sortBy) {
            case 'updateDate':
                return content => getYearDate(content.dateDebut || content.updateDate)
            case 'status':
                return content => getLabel(statusOptions, content.status, null, 'code')
            case 'category':
                return content => getLabel(cmsCategories, content.idCategory, 'title', 'id')
            default:
                return sortBy
        }
    }

    getResult = filteredEvents => {
        const { sortBy } = this.state
        if (!filteredEvents.length) {
            return (
                <h4 className='center-align padding-top-1 padding-bottom-1'>{i18n.noContentToDisplay}</h4>
            )
        }
        const orderedEvents = orderBy(filteredEvents.map((e) => ({ ...e, sortDate: e.dateDebut || e.updateDate })), ['sortDate'], ['desc'])
        const groups = groupBy(orderedEvents, this.getSortByFunction())
        return orderBy(Object.keys(groups), [], ['updateDate', 'status'].includes(sortBy) ? 'desc' : 'asc').map((key, i) => {
            const size = groups[key].length
            const label = size > 1 ? i18n.elements : i18n.element
            const cards = orderBy(groups[key], 'updateDate', 'desc').map(e => (
                <ColorfulCard key={e.id} color={hasValue(e.level) ? getNewsColor(e.level) : 'null'}>
                    <CmsCard cms={e} />
                </ColorfulCard>
            ))
            return (
                <Grid2 key={key}>
                    <Accordion defaultExpanded={i === 0} round>
                        <AccordionSummary round>
                            {`${key} (${size} ${label})`}
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                            {cards}
                        </AccordionDetails>
                    </Accordion>
                </Grid2>
            )
        })
    }

    getCategoriesSelect = (categories) => {
        const category = categories.find(c => c.id == this.props.params.categoryId)
        if (category && category.displayOnMenu) {
            const menuCategories = categories.filter(c => c.displayOnMenu && c.menu === category.menu).map(c => deleteKeys(c, ['icon']))
            return (
                <Grid2 size={6}>
                    <Select
                        options={menuCategories}
                        label={i18n.category}
                        value={this.state.tmpFilter.category}
                        keyvalue='id'
                        keyLabel='title'
                        nullLabel='TOUTES'
                        onChange={v => this.onChangeFilter('category', hasValue(v) ? parseInt(v) : null)}
                    />
                </Grid2>
            )
        }
        return null
    }

    filterCMSByAuth = (events, user) => {
        if (user.admin === '1') {
            return events
        }
        if (user.metadata === '1') {
            return events.filter((e) => e.authorization !== 'admin')
        }
        if (user.labo === '1') {
            return events.filter((e) => !e.authorization || ['anim', 'all'].includes(e.authorization))
        }
        return events.filter((e) => !e.authorization || e.authorization === 'all')
    }

    getFilteredCMSEvents = events => {
        const {
            category,
            status,
            level,
            searchValue,
        } = this.state.filter
        const { cmsCategories, params } = this.props
        const user = getUser()
        const cmsCategory = cmsCategories.find((c) => c.id === parseInt(params.categoryId))
        const categoriesIds = cmsCategories.filter((c) => c.displayOnMenu && c.menu === cmsCategory.menu).map((c) => c.id)
        const filterAuthorization = this.filterCMSByAuth(events, user)
        const filterLevel = level !== -1 ? filterAuthorization.filter(({ levelContent }) => level === levelContent) : filterAuthorization
        const filterCategory = hasValue(category) ? filterLevel.filter(({ idCategory }) => idCategory === category) : filterLevel.filter(({ idCategory }) => categoriesIds.includes(idCategory))
        const filterStatus = status !== -1 ? filterCategory.filter(e => e.status === status) : filterCategory

        const filterUser = user.admin !== '1' ? filterStatus.filter(e => e.status !== 2 || (e.status === 2 && e.login === user.login)) : filterStatus

        const searchValueFormat = searchAllCharacters(searchValue)
        return hasValue(searchValueFormat) ? filterUser.filter(({ title, subtitle, comment, author }) => searchAllCharacters(`${title}${subtitle}${comment}${author}`).includes(searchValueFormat)) : filterUser
    }

    getCMSFromCategory = events => {
        return this.getResult(this.getFilteredCMSEvents(events))
    }

    getStatusList = () => {
        const { sandreCodes } = this.props
        const statusOptions = [
            { value: -1, label: i18n.all },
            ...sandreCodes.filter((c) => c.field === 'CMS.STATUS'),
        ]
        return (
            <Grid2 size={6}>
                <Select
                    options={statusOptions}
                    label={i18n.status}
                    value={this.state.tmpFilter.status}
                    keyLabel='label'
                    noNullValue
                    integerValue
                    onChange={v => this.onChangeFilter('status', v)}
                />
            </Grid2>
        )
    }

    getLevelList = () => {
        const levelOptions = ['blue', 'green', 'orange', 'red'].map((c, i) => ({
            label: <span className={`${c} arrests-level-panel ${c}-text`}>O</span>,
            value: i + 1,
        }))
        const allLevelOptions = [
            {
                value: -1,
                label: i18n.everybody,
            },
            ...levelOptions,
        ]
        return (
            <RadioButtons
                elements={allLevelOptions}
                selected={this.state.tmpFilter.level}
                title={i18n.level}
                onChange={v => this.onChangeFilter('level', parseInt(v))}
            />
        )
    }

    getActive = panel => {
        return panel === this.state.sortBy ? 'active' : ''
    }

    onChangeFilter = (filter, value) => {
        const newObj = {}
        newObj[filter] = value
        if (filter === 'category') {
            newObj.sortBy = 'updateDate'
        }
        this.setState({ tmpFilter: { ...this.state.tmpFilter, ...newObj } })
    }

    onValidate = () => {
        const { cmsCategories, params } = this.props
        const { tmpFilter } = this.state
        this.setState({ filter: { ...tmpFilter } })
        this.props.sieauUpdate('selectedSearchValues', 'content', { category: tmpFilter.category })
        const category = cmsCategories.find(c => c.id == tmpFilter.category || c.id == params.categoryId)
        const name = category.displayOnMenu && category.menu ? category.menu : category.title
        const categorySelected = cmsCategories.find(c => c.id == tmpFilter.category)
        this.props.setTitle([{
            title: name,
            href: `${PATH_CONTENTS}/${params.categoryId}`,
        }, {
            title: categorySelected ? categorySelected.title : 'TOUTES',
            href: `${PATH_CONTENTS}/${params.categoryId}`,
        }])
    }

    componentDidUpdate(prevProps) {
        const { zeroResult } = this.state
        const { cmsCategories, cmsEvents, params } = this.props
        const results = this.getFilteredCMSEvents(cmsEvents).length
        if (results && zeroResult) {
            this.setState({ zeroResult: false })
        } else if (!results && !zeroResult) {
            this.setState({ zeroResult: true })
        }
        if ((cmsCategories.length && !isEqual(prevProps.cmsCategories, cmsCategories)) ||
            params.categoryId !== prevProps.params.categoryId) {
            this.setState({ filter: initFilter, tmpFilter: initFilter })
            this.setTitle(this.props, initFilter)
        }
    }

    getEvents = () => {
        return this.props.cmsEvents.map((o) => {
            if (o.categoryWPName) {
                return { ...o, idCategory: -1 }
            }
            return o
        })
    }

    onReinit = () => {
        this.setState({ filter: initFilter, tmpFilter: initFilter })
        this.setTitle(this.props, initFilter)
    }

    render() {
        const { tmpFilter, dataLoaded, sortBy } = this.state
        const { cmsCategories } = this.props
        const events = this.getEvents()

        return (
            <>
                <Grid2 container direction='column' alignItems='center' spacing={1} sx={{ margin: '10px' }}>
                    <Grid2 size={{ md: 8, sm: 12 }}>
                        <Card className='padding-1'>
                            <Grid2 container spacing={1}>
                                {this.getCategoriesSelect(cmsCategories)}
                                {this.getStatusList()}
                                <Grid2 size={6}>
                                    <Input
                                        title={i18n.search}
                                        value={tmpFilter.searchValue}
                                        onChange={v => this.onChangeFilter('searchValue', v)}
                                        onEnterKeyPress={this.onValidate}
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    {this.getLevelList()}
                                </Grid2>
                                <Grid2 size={12} container justifyContent='flex-end'>
                                    <Grid2>
                                        <Button variant='outlined' onClick={this.onReinit}>
                                            {i18n.reinit}
                                        </Button>
                                    </Grid2>
                                    <Grid2>
                                        <Button variant='contained' onClick={this.onValidate}>
                                            {i18n.search}
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Card>
                    </Grid2>
                    <Grid2 size={{ md: 8, sm: 12 }}>
                        {dataLoaded ? (
                            <SimpleTabList
                                controlTab={sortBy}
                                setControlTab={(v) => this.onChangeSortBy(v)}
                                tabs={[
                                    {
                                        constant: 'updateDate',
                                        label: i18n.perYear,
                                        icon: 'insert_invitation',
                                    },
                                    {
                                        constant: 'author',
                                        label: i18n.byAuthor,
                                        icon: 'person',
                                    },
                                    {
                                        constant: 'category',
                                        label: i18n.byCategory,
                                        icon: 'fiber_new',
                                    },
                                    {
                                        constant: 'status',
                                        label: i18n.byStatus,
                                        icon: 'edit',
                                    },
                                ]}
                            >
                                {() => (
                                    <Grid2 container direction='column' spacing={1}>
                                        {this.getCMSFromCategory(events)}
                                    </Grid2>
                                )}
                            </SimpleTabList>
                        ) : <ProgressCard indeterminate round />}
                    </Grid2>
                </Grid2>
            </>
        )
    }
}

ContentsApp.propTypes = getPropTypes(propsToFetch, {
    params: PropTypes.shape({
        categoryId: PropTypes.number,
        globalResearch: PropTypes.string,
    }),
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    accountUser: PropTypes.instanceOf(User),
})

const mapStateToProps = (store) => getMapStateToProps(propsToFetch, {
    globalResearch: store.HomeReducer.globalResearch,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    accountUser: store.AccountReducer.accountUser,
})

const mapDispatchToProps = {
    setTitle: HomeAction.setTitle,
    fetchCMSEvents: CmsAction.fetchCMSEvents,
    fetchCMSCategories: CmsAction.fetchCMSCategories,
    sieauUpdate: SieauAction.update,
    sieauFetch: SieauAction.fetch,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentsApp)
